import React from 'react';
import PropTypes from 'prop-types';
import {Button} from 'reactstrap';

export default function MemberOrderActionFooter({actions}) {
    if (!Array.isArray(actions) || actions.length === 0) {
        return null;
    }

    return (
        <div className="member-order-detail__footer">
            <div className="member-order-detail__footer-actions">
                {actions.map((action) => (
                    <Button
                        key={action.key || action.label}
                        color={action.color || 'primary'}
                        outline={action.outline === true}
                        className={`member-order-action-btn ${action.className || ''}`}
                        onClick={action.onClick}
                    >
                        {action.icon && (
                            <i className="material-icons member-order-action-btn__icon" aria-hidden="true">
                                {action.icon}
                            </i>
                        )}
                        <span className="member-order-action-btn__label">{action.label}</span>
                    </Button>
                ))}
            </div>
        </div>
    );
}

MemberOrderActionFooter.propTypes = {
    actions: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string,
        label: PropTypes.string.isRequired,
        icon: PropTypes.string,
        onClick: PropTypes.func.isRequired,
        color: PropTypes.string,
        outline: PropTypes.bool,
        className: PropTypes.string,
    })),
};
